// Run this example by adding <%= javascript_pack_tag 'directory' %> to your desired file.

import React from 'react'
import ReactDOM from 'react-dom'
import Directory from '../directory/Directory'

const rootElement = document.getElementById('directory')
const type = rootElement.dataset.type

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Directory type={type} />,
    rootElement
  )
})